import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SopoTransitionService } from '../../services/sopo-transition/sopo-transition.service';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';
import { SopoLoadingService } from '../../services/sopo-loading/sopo-loading.service';

@Component({
    selector: 'app-sopo-transition',
    templateUrl: './sopo-transition.component.html',
    styleUrls: ['./sopo-transition.component.scss'],
    animations: [
        trigger('leftBackground', [
            state('closed', style({ translate: '-50% -50%' })),
            transition('not-closed => closed', animate('400ms 100ms ease-in-out')),
            transition('closed => not-closed', animate('600ms 100ms ease-in-out')),
        ]),
        trigger('rightBackground', [
            state('closed', style({ translate: '50% -50%' })),
            transition('not-closed => closed', animate('400ms 100ms ease-in-out')),
            transition('closed => not-closed', animate('600ms 100ms ease-in-out')),
        ]),
        trigger('leftImage', [
            state('closed', style({ translate: '0' })),
            transition('not-closed => closed', [
                animate('700ms ease-out'),
            ]),
            transition('closed => not-closed', [
                animate('800ms ease-in-out'),
            ])
        ]),
        trigger('rightImage', [
            state('closed', style({ translate: '0' })),
            transition('not-closed => closed', [
                animate('700ms ease-out')
            ]),
            transition('closed => not-closed', [
                animate('800ms ease-in-out'),
            ])
        ]),
    ],
    standalone: false
})
export class SopoTransitionComponent implements OnInit, OnDestroy {
    private _leftBackgroundState: AnimationState = 'void';
    private _rightBackgroundState: AnimationState = 'void';
    private _leftImageState: AnimationState = 'void';
    private _rightImageState: AnimationState = 'void';
    private _transitionState: BehaviorSubject<AnimationState> = new BehaviorSubject('void');
    closed = false;

    constructor(
        public sopoTransition: SopoTransitionService,
        public ref: ChangeDetectorRef,
        private loadingService: SopoLoadingService,
    ) {}

    ngOnInit() {
        this.loadingService.pause();
    }

    ngOnDestroy() {
        this.loadingService.resume();
    }

    getTransitionStateObservable(): Observable<AnimationState> {
        return this._transitionState.asObservable().pipe(distinctUntilChanged());
    }

    done(event: any) {
        switch (event.triggerName) {
            case 'leftBackground':
                this._leftBackgroundState = event.toState;
                break;
            case 'rightBackground':
                this._rightBackgroundState = event.toState;
                break;
            case 'leftImage':
                this._leftImageState = event.toState;
                break;
            case 'rightImage':
                this._rightImageState = event.toState;
                break;
        }
        if (
            this._leftBackgroundState === 'not-closed' &&
            this._rightBackgroundState === 'not-closed' &&
            this._leftImageState === 'not-closed' &&
            this._rightImageState === 'not-closed'
        ) {
            this._transitionState.next('not-closed');
        }
        if (
            this._leftBackgroundState === 'closed' &&
            this._rightBackgroundState === 'closed' &&
            this._leftImageState === 'closed' &&
            this._rightImageState === 'closed'
        ) {
            this._transitionState.next('closed');
        }
    }
}

export type AnimationState = 'void' |'closed' | 'not-closed';